import styled from 'foundations-theming-specialty/utils';
export const StyledSettingsLink = styled.div.withConfig({
  displayName: "StyledSettingsLink",
  componentId: "rup1s-0"
})(["display:", ";align-items:center;justify-content:center;position:", ";z-index:2;width:32px;height:48px;top:", ";left:", ";cursor:pointer;button{border:none;background:none;padding:0;margin:0;cursor:pointer;font-size:26px;color:gray;}"], ({
  isOpen
}) => isOpen ? 'flex' : 'none', ({
  isOpen
}) => isOpen ? 'absolute' : 'relative', ({
  theme,
  isOpen
}) => isOpen ? theme.space['400'] : 0, ({
  theme,
  isOpen
}) => isOpen ? `calc(${theme.space['600']} + 467px + ${theme.space['200']})` : 0);